import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useHistory } from 'react-router-dom';
import { IconButton, Icon, Grid, Typography, FormGroup, FormControl, FormLabel, FormControlLabel, Checkbox, Button, Tooltip, Box, CircularProgress } from '@material-ui/core';
import { green, red } from '@material-ui/core/colors';
import { toastr } from 'react-redux-toastr';
import { URL } from '../../assets/js/constants';

import { getFuncionarios } from '../../store/actions/funcionario';
import { getListaPerfilAdmin, atualizarPerfilUsuarioAdmin } from '../../store/actions/usuario';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';

const Funcionario = props => {
    const history = useHistory();
    const {
        user,
        funcionarios,
        getFuncionarios,
        getListaPerfilAdmin,
        listaPerfilAdmin,
        atualizarPerfilUsuarioAdmin,
        loading
    } = props;
    const { perfis } = user;

    const [toggleAdminAtualizarPerfilDialog, setToggleAdminAtualizarPerfilDialog] = useState(false);
    const [selectedPerfis, setSelectedPerfis] = useState('');
    const [usuarioNovoPerfil, setUsuarioNovoPerfil] = useState('');

    useEffect(_ => {
        getFuncionarios();
        getListaPerfilAdmin();
    }, []);

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: 'Matrícula',
            selector: (row) => row.matricula,
            width: '120px',
            sortable: true,
        },
        {
            name: 'Nome',
            selector: (row) => row.nomeCompleto,
            sortable: true,
        },
        {
            name: 'CPF',
            selector: (row) => row.cpf,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Negócio',
            selector: (row) => row.nomeNegocio,
            sortable: true,
            width: '250px',
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (
                row.ativo ? <Icon fontSize='small' style={{ color: green[500] }}>check_circle</Icon> : <Icon fontSize='small' style={{ color: red[500] }}>cancel</Icon>
            ),
            width: '100px',
            sortable: true,
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Editar Funcionário' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="editar" size='small' color='secondary' onClick={() => handleEditarFuncionario(row.id)}><Icon>edit</Icon></IconButton>
                    </Tooltip>

                    {perfis.includes('ADMIN_APP') && (
                        <>
                            <Tooltip title='Cadastrar/Editar Endereço' placement='right'>
                                <IconButton style={{ padding: 1 }} aria-label="enderecos" size='small' color='secondary' onClick={() => handleEditarEndereco(row.id)}><Icon>add_location_alt</Icon></IconButton>
                            </Tooltip>
                            <Tooltip title='Perfil de Acesso' placement='right'>
                                <IconButton style={{ padding: 1 }} aria-label="perfilAdmin" size="small" color="primary" onClick={() => toggleDialogPerfilAdmin(row.idUsuario)}><Icon>security</Icon></IconButton>
                            </Tooltip>
                        </>
                    )}

                </>
            ),
            width: '100px'
        }
    ];

    const handleEditarFuncionario = (id) => {
        history.push({
            pathname: '/funcionarios-da-loja/editar-funcionario',
            state: {
                funcionarioId: id,
                from: window.location.pathname,
            },
        });
    }

    const handleEditarEndereco = (id) => {
        history.push({
            pathname: '/enderecos/editar-endereco-funcionario',
            state: {
                funcionarioId: id,
                from: window.location.pathname,
            },
        });
    }

    async function toggleDialogPerfilAdmin(idUsuario) {
        try {
            const perfil = await perfilDoUsuarioAdmin(idUsuario);
            setSelectedPerfis(perfil || []);
            setUsuarioNovoPerfil(idUsuario);
            setToggleAdminAtualizarPerfilDialog(true);
        } catch (error) {
            console.error("Erro ao buscar perfil:", error);
        }
    }

    function handleConfirmarPerfilAdmin() {
        const data = { id: usuarioNovoPerfil, perfis: selectedPerfis }
        atualizarPerfilUsuarioAdmin(data);
        setToggleAdminAtualizarPerfilDialog(false);
    }

    function handleChangePerfilAdmin(event) {
        const { name, checked } = event.target;

        if (checked) {
            // adiciona perfil
            setSelectedPerfis([...selectedPerfis, name]);
        } else {
            // remove perfil
            setSelectedPerfis(selectedPerfis.filter(p => p !== name));
        }
    };

    async function perfilDoUsuarioAdmin(idUsuario) {
        try {
            const response = await axios.get(`${URL}/usuarios/perfil-do-usuario/${idUsuario}`);
            return response.data;
        } catch (e) {
            toastr.error('Erro', 'Não foi possível atualizar lista de funcionários. Erro: ' + e.message);
            throw e;
        }
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Funcionarios' subtitulo={new Date().toLocaleString('pt-BR')} />

            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={funcionarios}
                    visibleSearch={funcionarios && funcionarios.length > 0}
                    camposParaBusca={['matricula', 'nomeCompleto', 'cpf', 'nomeNegocio']}
                />
                <Grid container >
                    <Button component={Link} variant='contained' color='secondary' to={{ pathname: '/funcionarios-da-loja/cadastrar-funcionario', state: { from: window.location.pathname } }}>Cadastrar Funcionário</Button>
                </Grid>
            </Box>

            <DialogAlert
                title='Administrador - Definir Perfil do Funcionário'
                fullWidth={true}
                maxWidth='sm'
                okButton={true}
                okButtonType='submit'
                okButtonClick={() => handleConfirmarPerfilAdmin()}
                labelOkButton='Confirmar'
                cancelButton={true}
                cancelButtonClick={() => setToggleAdminAtualizarPerfilDialog(false)}
                labelCancelButton='Cancelar'
                openDialog={toggleAdminAtualizarPerfilDialog}
            >
                <Grid container item>
                    <Grid item xs >
                        <Typography variant="subtitle1" style={{ color: '#999997', paddingBottom: '15px' }}>Selecione o novo perfil do funcionário.</Typography>
                        <Grid item sx>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Perfil</FormLabel>
                                <FormGroup >
                                    {
                                        listaPerfilAdmin.map(p => <FormControlLabel
                                            key={p}
                                            control={
                                                <Checkbox
                                                    checked={selectedPerfis.includes(p)}
                                                    onChange={handleChangePerfilAdmin}
                                                    name={p}
                                                    color="primary"
                                                />} label={p} />)
                                    }
                                </FormGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogAlert>
        </>
    )
}

const mapStateToProps = state => ({
    user: state.auth.user,
    funcionarios: state.funcionario.funcionarios,
    loading: state.funcionario.loading,
    listaPerfilAdmin: state.usuario.listaPerfilAdmin,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getFuncionarios,
    getListaPerfilAdmin,
    atualizarPerfilUsuarioAdmin
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Funcionario);